import Big from 'big.js'
import { useContext } from 'react'

import { MetronomeContext } from '../components/MetronomeContext'

const useProjectedDebtInUsd = function ({
  usdRate,
  inputValue = 0,
  operation
}) {
  const {
    debtPosition: { debtInUsd = 0 }
  } = useContext(MetronomeContext)

  if (['generate', 'repay'].includes(operation)) {
    const inputValueInUsd = usdRate
      ? Big(inputValue).times(usdRate)
      : inputValue
    return operation === 'generate'
      ? Big(debtInUsd).plus(inputValueInUsd)
      : Big(debtInUsd).minus(inputValueInUsd)
  }

  return debtInUsd
}

export default useProjectedDebtInUsd
